import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ref } from 'airbnb-prop-types';

import { Container } from './ProductStickyContainer.styled';

const ProductStickyContainer = ({
  children,
  noFilters,
  bottomSpacing,
  productsGridRef,
}) => {
  const relativeElRef = useRef(null);
  const layoutSwitcherRef = useRef(null);
  const [hasProductListAppear, setHasProductListAppear] = useState(false);
  const [hasReachedProductListEnd, setHasReachedProductListEnd] =
    useState(false);

  useEffect(() => {
    const handleIntersectionChange = ([{ isIntersecting }]) => {
      setHasProductListAppear(isIntersecting);
    };

    const productsGrid = productsGridRef.current;
    const productsGridObserver = new IntersectionObserver(
      handleIntersectionChange,
      {
        threshold: 0,
      },
    );

    productsGridObserver.observe(productsGrid);

    return () => {
      productsGridObserver.unobserve(productsGrid);
    };
  }, [productsGridRef]);

  useEffect(() => {
    if (!relativeElRef.current || !layoutSwitcherRef.current) {
      return undefined;
    }

    const handleIntersectionChange = ([{ isIntersecting }]) => {
      if (!relativeElRef.current || !layoutSwitcherRef.current) {
        return;
      }

      const { top } = relativeElRef.current?.getBoundingClientRect() || {
        top: 0,
      };

      setHasReachedProductListEnd(
        !(top - layoutSwitcherRef.current.offsetHeight > 0 && !isIntersecting),
      );
    };

    const relativeElObserver = new IntersectionObserver(
      handleIntersectionChange,
      {
        threshold: 1,
        rootMargin: `-${layoutSwitcherRef.current.offsetHeight || 0}px`,
      },
    );

    relativeElObserver.observe(relativeElRef.current);

    return () => {
      relativeElObserver.disconnect();
    };
  }, [relativeElRef.current, layoutSwitcherRef.current]);

  return (
    <React.Fragment>
      <div ref={relativeElRef} />
      <Container
        ref={layoutSwitcherRef}
        noFilters={noFilters}
        bottomSpacing={bottomSpacing}
        isSwitcherVisible={hasProductListAppear && !hasReachedProductListEnd}
      >
        {children}
      </Container>
    </React.Fragment>
  );
};

ProductStickyContainer.propTypes = {
  children: PropTypes.node.isRequired,
  noFilters: PropTypes.bool,
  bottomSpacing: PropTypes.string,
  productsGridRef: ref().isRequired,
};

ProductStickyContainer.defaultProps = {
  noFilters: false,
  bottomSpacing: undefined,
};

export default ProductStickyContainer;
